import _ from "lodash";


export const
    switchable_element = (element) => {
        const default_element = element, marker = document.createComment('--s-s--');

        let prev_el = default_element, current_el = default_element;

        const s = (el) => {
            if (current_el.isConnected) current_el.parentNode.replaceChild(el, current_el);
            prev_el = current_el;
            current_el = el;
        };

        const show = (boolean = true) => {
            if (current_el.isConnected == boolean) return;
            if (boolean) marker.parentNode.replaceChild(current_el, marker);
            else current_el.parentNode.replaceChild(marker, current_el);
        };

        return {
            switch: (el) => { s(el) },
            back_default: () => { s(default_element) },
            hide: (b = true) => { show(!b) },
            show,
            current: () => current_el,
            marker: () => marker,
            is_visible: () => current_el.isConnected
        };
    },
    obj_to_querystring = obj => '?' + new URLSearchParams(_.pickBy(obj, e => e != null)).toString(),
    byteMetter = (total = 0, current = 0) => {
        let unity = total <= 1024 ? 'B' : total < Math.pow(1024, 2) ? 'KB' : 'MB';
        const calc = (v) => { return unity === 'B' ? v : unity === 'KB' ? v / 1024 : unity === 'MB' && v / Math.pow(1024, 2) };
        return { unity, total: calc(total), current: calc(current) }
    },
    time_metter = (time_ms) => {
        return time_ms <= 1000 ?
            { unity: "ms", time: time_ms } : time_ms <= (1000 * 60) ?
                { unity: "sec", time: time_ms / 1000 } :
                { unity: "min", time: (time_ms / 60000) };
    },
    path_name_regex = new RegExp("^[a-zA-Z-_0-9]+$"),
    smooth_hide = (classname, switchable) => {
        if (switchable.is_visible) {
            const c = switchable.current();

            const remove = () => {
                switchable.hide();
                c.classList.remove(classname);
                c.removeEventListener("animationend", remove)
            };

            c.addEventListener("animationend", remove);

            c.classList.add(classname);
        };
    },
    max_height_ajustment = (section, calc_callback) => {
        let height;

        const resizeObserver = new ResizeObserver(entries => {
            if (height !== entries[0].target.clientHeight && _.isFunction(calc_callback)) {
                height = entries[0].target.clientHeight;
                section.style.maxHeight = calc_callback(height) + 'px';
            };
        })

        resizeObserver.observe(document.body);

        return section;
    },
    dimension_adjustment = (section, dimAjust) => {
        let height, width, { on_width, on_height } = dimAjust;

        if (!on_height && !on_width) return;

        const resizeObserver = new ResizeObserver(entries => {
            if (height !== entries[0].target.clientHeight && isFunction(on_height)) {
                height = entries[0].target.clientHeight;
                section.style.height = on_height(height) + 'px';
            };

            if (width !== entries[0].target.clientWidth && isFunction(on_width)) {
                width = entries[0].target.clientWidth;
                section.style.width = on_width(width) + 'px';
            };
        });

        resizeObserver.observe(document.body)
    },
    input_params_by_class = (type) => {
        if (type == 'Boolean') return { type: 'boolean-select' }
        if (["Double", "Float"].includes(type)) return { type: 'numeric' };
        if (["Integer", "Long", "Short"].includes(type)) return { type: 'integer', };

        return { type: "text" };
    },
    just_numbers_input = (e, ...allowed) => {
        const allowedKeys = ['Backspace', 'Enter', ...allowed];

        let event = e || window.event
        let key = event.key, regex = /^[0-9]+$/;

        if (!regex.test(key) && !allowedKeys.some(i => i === key)) {
            event.returnValue = false;
            if (event.preventDefault) event.preventDefault();
        };
    },
    btn_handler = (shared) => {

        const d = (name, bool = true) => shared[name][bool ? "disable" : "enable"]();

        const disable = (names, bool = true) => {
            if (_.isArray(names)) _.forEach(names, e => { d(e, bool) });
            else d(names, bool)
        };

        return {
            enable_btn: (names, bool = true) => disable(names, !bool),
            disable_btn: disable
        };
    },
    next_input_chain = (shared = {}) => (next_one) => {
        return (evt) => {
            if (evt.key !== 'Enter') return
            evt.preventDefault();
            shared[next_one].element.focus();
        }
    },
    key_sequence_listener = (keys, callback) => {
        const key_log = {}, key_sequence = [...keys], events = ['keydown', 'keyup'];

        const handle = ({ type, key, repeat, metaKey }) => {
            if (repeat) return

            if (type === 'keydown') {
                key_log[key] = true;

                const key_log_pairs = _.toPairs(key_log);

                if (_.every(key_sequence, (e, i) => !key_log_pairs[i] ? false : (key_log_pairs[i][0] == e && key_log_pairs[i][1]))) callback && callback()
            }
            if (type === 'keyup') delete key_log[key]
        }

        _.forEach(events, e => document.addEventListener(e, handle));

        return () => _.forEach(events, e => document.removeEventListener(e, handle));
    },
    get_object_from_storage = (sbj) => {
        try {
            const o = localStorage.getItem(sbj);
            return JSON.parse(o) ?? {};
        } catch (e) {
            return {};
        };
    },
    set_object_on_storage = (sbj, obj) => {
        localStorage.setItem(sbj, JSON.stringify(obj));
        return obj;
    },
    patch_object_on_storage = (sbj, obj) => {
        let o = get_object_from_storage(sbj);
        o = _.merge(o, obj);
        set_object_on_storage(sbj, o);
        return o;
    },
    dark_theme = (bool) => {
        document.body.classList[bool ? "add" : "remove"]("dark");
        patch_object_on_storage("user_data", { dark_theme: bool });
    },
    dark_theme_stored = () => !!get_object_from_storage("user_data")?.dark_theme


